export const TestId = {
  root: 'UserSettingsPage',
  title: 'UserSettingsPage-title',
}
